import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Typography from '@mui/material/Typography';
import CardContent from '@mui/material/CardContent';
import AssessmentIcon from '@mui/icons-material/Assessment';
import { updateBreadcrumb } from '#action/breadcrumb';
import {
  PageContainer,
  HeaderSection,
  ReportTypesGrid,
  ReportTypeCard,
  ReportIconWrapper,
  ComingSoonBadge
} from './styles';
import { setDocumentTitle } from '#helper';

const reportTypes = [
  {
    id: 'application-excursion',
    title: 'Application Excursion Report',
    description: 'Monthly excursion report for a project showing all threshold violations across sites and applications.',
    icon: AssessmentIcon,
    color: '#d32f2f',
    available: true
  }
];

const Reports = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    setDocumentTitle('Reports');
    dispatch(updateBreadcrumb([
      { label: 'Reports' }
    ]));
  }, [dispatch]);

  const handleReportSelect = report => {
    if (report.available) {
      history.push(`/reports/${report.id}`);
    }
  };

  return (
    <PageContainer>
      <HeaderSection>
        <Typography variant="h4" gutterBottom>
          Reports
        </Typography>
        <Typography variant="body1" color="textSecondary">
          Select a report type to generate
        </Typography>
      </HeaderSection>

      <ReportTypesGrid>
        {reportTypes.map(report => {
          const IconComponent = report.icon;
          return (
            <ReportTypeCard
              key={report.id}
              onClick={() => handleReportSelect(report)}
              available={report.available}
            >
              <CardContent>
                <ReportIconWrapper color={report.color}>
                  <IconComponent />
                </ReportIconWrapper>
                <Typography variant="h6" gutterBottom>
                  {report.title}
                  {!report.available && (
                    <ComingSoonBadge component="span" variant="caption">
                      (Coming soon)
                    </ComingSoonBadge>
                  )}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  {report.description}
                </Typography>
              </CardContent>
            </ReportTypeCard>
          );
        })}
      </ReportTypesGrid>
    </PageContainer>
  );
};

export default Reports;
